import React, { useState, useEffect, Fragment } from "react";
import HotelCard from "./Components/ServicioCard";
import HotelBooking from "./Components/Booking/HotelBooking";
import CardFilter from "./Components/CardFilter";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import axios from "axios";
import GetCriteriaHotels from "./Components/GetCriteriaHotels";
import Box from "@material-ui/core/Box";
import Pagination from "@material-ui/lab/Pagination";
import { useTheme } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import LoadingHotels from "./Components/Hotels/LoadingHotels";
import Iframe from 'react-iframe'
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import queryString from "query-string";
import {useHistory} from "react-router-dom";
// import { BrowserRouter, useHistory } from "react-router-dom";
import NotAvailability from "./Components/Hotels/NotAvailability";
// import { CompareSharp } from "@material-ui/icons";

/* function wait(ms) {
  var start = new Date().getTime();
  var end = start;
  while (end < start + ms) {
    end = new Date().getTime();
  }
} */

export default function App() {
  const [dataHotels, setdataHotels] = useState([]);
  const [dataHotelsDestacados, setdataHotelsDestacados] = useState([]);
  const [dataBooking, setdataBooking] = useState([]);
  const [dataHotelsDetails, setdataHotelsDetails] = useState([]);
  const [searchToken, setsearchToken] = useState("");
  const [searchObject, setsearchObject] = useState({});
  const [principalSearch, setPrincipalSearch] = useState(true);
  const [ShowDestacados, setShowDestacados] = useState(false);
  const [ShowDestacadosAux, setShowDestacadosAux] = useState(false);
  const [flagNotAvailability, setFlagNotAvailability] = useState(false);
  const [firstSearch, setfirstSearch] = useState(false);
  const [firstPagination, setFirstPagination] = useState(1);
  const [indexPagination, setIndexPagination] = useState(1);
  const [precioDesde, setPrecioDesde] = useState(0);
  const [precioHasta, setPrecioHasta] = useState(0);
  const [indDestacados, setIndDestacados] = useState(false);
  const [urlAgencia, seturlAgencia] = useState("");
  const [TotalPagination, setTotalPagination] = useState(1);
  const [AgenciaWeb, setAgenciaWeb] = useState("Atom");
  // const [expanded, setExpanded] = React.useState("panel1");
  const [paginationObject, setPaginationObject] = useState({
    filltersCat: {},
    hotel: "",
    token: "",
    indicePaginacion: "",
    precioRango: [],
    filltersReg: {},
  });
  const [open, setOpen] = React.useState(false);
  const [bookingFlag, setbookingFlag] = React.useState(false);
  const [epale, SetEpale] = React.useState("false");
  const [epaleDestacados, SetEpaleDestacados] = React.useState("false");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [paxes, setPaxes] = React.useState([]);
  const [flagMensajeEspera, setFlagMensajeEspera] = React.useState("false");
  const [flagFilter, setFlagFilter] = React.useState(false);

  // const tiempoEspera = 3000;
  // const history = useHistory();

  // ---------------------- STYLE ---------------------------
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    GridBarra: {
      paddingLeft: "1px",
    },
    paper: {
      padding: theme.spacing(0),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    pagination: {
      color: "#016AA2",
      "& .Mui-selected": {
        backgroundColor: "#016AA2",
        color: "white",
      },
    },
    paper2: {
      padding: 0,
      margin: 0,
      color: theme.palette.text.secondary,
      backgroundColor: "#016AA2",
    },
    container: {
      maxWidth: "1240px",
      backgroundColor: "white",
      height: "100%",
      padding: "0px",
      boxShadow: "0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%)"   
    },
    fondoGetCriteria: {
      width: "98%",
      height: "300px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    fondoGetCriteriaPag: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      paddingTop: "0.5%",
    },
    divFondo: {
      backgroundColor: "white",
      paddingTop: "0%",
      /*  boxShadow: "1px 0px 7px 0px rgba(0,0,0,0.31)",
      WebkitBoxShadow: "1px 0px 7px 0px rgba(0,0,0,0.31)",
      MozBoxShadow: "1px 0px 7px 0px rgba(0,0,0,0.31)",
      borderRadius: "7px", */
    },
    buttonSeguimos: {
      color: "#FE5215",
      borderColor: "#FE5215",
      paddingTop: "0px",
      paddingBottom: "0px",
    },
    Pagination: {
      "& > *": {
        marginTop: theme.spacing(2),
        width: "100%",
        height: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#F3F2F1",
      },
      criterio: {
        marginLeft: "2%",
        marginRight: "2%",
      },
    },
  }));

  const classes = useStyles();

  const sectionStyleFondo = {
    backgroundImage: "url('/Images/fondoweb.jpg') ",
paddingTop: "10px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "auto",
    minHeight: "1100px",
  };

  const sectionStyle = {
    backgroundImage:
      "linear-gradient(rgba(255,255,255,.5), rgba(255,255,255,.5)), url('/Images/lobbyhotel.jpg')",
    // "url('/Images/lobbyhotel.jpg') ",

    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderRadius: "7px",
    margin: "10px"
  };

  /*   const sectionStyle2 = {
      margingTop: "0.5%",
    }; */
  // ---------------------- STYLE (FIN) ---------------------------

  // ---------------------- USEEFFECT ---------------------------
  useEffect(() => {
    window.onbeforeunload = function () {
      return "Your work will be lost.";
    };
  });

  useEffect(() => {
    if (firstSearch) {
      // SearchHotelsDestacados();
      SearchHotels();
    }
  }, [searchObject]);

  useEffect(() => {
    if (searchToken == "") {
    } else {
    }
  }, [epaleDestacados]);

  useEffect(() => {
    if (searchToken == "") {
    } else {
      FillHotels();
    }
  }, [epale]);

  useEffect(() => {
    if (searchToken == "") {
    } else {
      setOpen(true);
      FillPaginationObject(
        paginationObject.filltersCat,
        paginationObject.hotel,
        paginationObject.token,
        indexPagination,
        paginationObject.precioRango,
        paginationObject.filltersReg,
        paginationObject.destacadosFiltro
      );
      window.location.href = "#one";
    }
  }, [indexPagination]);

  useEffect(() => {
    window.scrollTo(0, 0)
   
  }, []);

  useEffect(() => {
    console.log("jg")
    console.log(AgenciaWeb)
  }, [AgenciaWeb]);
  
  useEffect(() => {
    handleQueryString();
  });

  // ---------------------- USEEFFECT (FIN)---------------------------

  // ---------------------- API ---------------------------
  const SearchHotelsDestacados = () => {
    setOpen(true);
    setFirstPagination(1);
    setIndexPagination(1);
    setFlagMensajeEspera(false);
    setFlagFilter(true);
    searchObject.city = "15011";
    const url =
      "https://webtravel2-online.com/APIhoteles/api/BusquedaDestacados?session=" +
      searchObject.SearchToken +
      "D" +
      "&DestinationCode=" +
      searchObject.city +
      "&datefrom=" +
      searchObject.from +
      "&dateto=" +
      searchObject.to +
      "&" +
      searchObject.distribution +
      "&agencia=atom";
    axios
      .get(url, {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        // setsearchToken(searchObject.SearchToken + "D");
        var pp = new Date();
        SetEpaleDestacados(pp);
        /*  FillPaginationObject({
           cat5: false,
           cat4: false,
           cat3: false,
           cat2: false,
           cat1: false
         }, '', searchObject.SearchToken + 'D', 1, [0, 0], {
           SA: false,
           AD: false,
           MP: false,
           PC: false,
           TI: false
         }) */
        if (response.data.Disponibilidades.length > 0) {
          setFlagMensajeEspera(true);
          setShowDestacados(true);
          setPrincipalSearch(false);
          ProcesaServiciosResults(response.data, "Destacados");
        } else {
          setShowDestacados(false);
        }
      })
      .catch((error) => {
        setOpen(false);
        setsearchToken("");
      });
  };

  const SearchHotels = () => {
    setOpen(true);
    setFirstPagination(1);
    setIndexPagination(1);
    setFlagFilter(true);
    const url =
      "https://webtravel2-online.com/APIhoteles/api/BusquedaServicios?session=" +
      searchObject.SearchToken +
      "&DestinationCode=" +
      searchObject.city +
      "&datefrom=" +
      searchObject.from +
      "&dateto=" +
      searchObject.to +
      "&" +
      searchObject.distribution +
      "&agencia=atom";
    axios
      .get(url, {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        setsearchToken(response.data);
        FillPaginationObject(
          {
            cat5: false,
            cat4: false,
            cat3: false,
            cat2: false,
            cat1: false,
          },
          "",
          response.data,
          1,
          [0, 0],
          {
            SA: false,
            AD: false,
            MP: false,
            PC: false,
            TI: false,
          },
          0
        );
      })
      .catch((error) => {
        // setOpen(false);
        setsearchToken("");
        // console.log(error);
      });
      setShowDestacados(false);
 
  };

  const FillHotels = () => {
    var precioRango = paginationObject.precioRango;
    var filltersCat = paginationObject.filltersCat;
    var filltersReg = paginationObject.filltersReg;
    var hotel = paginationObject.hotel;
    var token = paginationObject.token;
    var indicePaginacion = paginationObject.indicePaginacion;
    var destacadosFiltro = paginationObject.destacadosFiltro;

 /*    let catFilter = filltersCat.cat5 ? "&categoria5=1" : "&categoria5=0";
    catFilter = filltersCat.cat4 ? catFilter + "&categoria4=1"  : catFilter + "&categoria4=0";
    catFilter = filltersCat.cat3
      ? catFilter + "&categoria3=1"
      : catFilter + "&categoria3=0";
    catFilter = filltersCat.cat2
      ? catFilter + "&categoria2=1"
      : catFilter + "&categoria2=0";
    catFilter = filltersCat.cat1
      ? catFilter + "&categoria1=1"
      : catFilter + "&categoria1=0"; */

    let regFilter = filltersReg.TI ? "&regimenTI=1" : "&regimenTI=0";
    regFilter = filltersReg.PC
      ? regFilter + "&regimenPC=1"
      : regFilter + "&regimenPC=0";
    regFilter = filltersReg.MP
      ? regFilter + "&regimenMP=1"
      : regFilter + "&regimenMP=0";
    regFilter = filltersReg.AD
      ? regFilter + "&regimenAD=1"
      : regFilter + "&regimenAD=0";
    regFilter = filltersReg.SA
      ? regFilter + "&regimenSA=1"
      : regFilter + "&regimenSA=0";

      //FILTRO POR ATRACCIONES
     
      if (hotel === "") {
        if (filltersCat.cat6) {
          hotel= hotel + "%filtroJB%6";
        } 
        if (filltersCat.cat5) {
          hotel= hotel + "%filtroJB%5";
        } 
        if (filltersCat.cat4) {
          hotel= hotel + "%filtroJB%4";
        } 
        if (filltersCat.cat3) {
          hotel= hotel + "%filtroJB%3";
        } 
        if (filltersCat.cat2) {
          hotel= hotel + "%filtroJB%2";
        } 
        if (filltersCat.cat1) {
          hotel= hotel + "%filtroJB%1";
        } 
      }
    /*   console.log("filtro");
      console.log(hotel);
      console.log(filltersCat); */

    /*     var hotelsList = [];
        var TotalPagineo = ""; */
    var precioDesdeX = precioRango[0];
    var precioHastaX = precioRango[1];
    //setOpen(true);

    const url =
      "https://webtravel2-online.com/APIhoteles/api/ServiciosPagineoRetrieve?pagina=" +
      indicePaginacion +
      "&cantidad=10" +
      "&nombre=" +
      hotel +
      "&minimo=" +
      precioDesdeX +
      "&maximo=" +
      precioHastaX +
      "&IdEncabezado=" +
      token;

      //const url ="https://run.mocky.io/v3/124e6443-047f-4ac5-b138-56b88b9324d1";
    axios
      .get(url, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "*",
        },
      })
      .then((response) => {
        if (ShowDestacadosAux) {
          setShowDestacados(true);
        }
        setFlagMensajeEspera(false);
        if (response.data.Disponibilidades.length > 0) {
          setPrincipalSearch(false);
         // ProcesaHotelsResults(response.data, "Todos");
         ProcesaServiciosResults(response.data, "Todos");
        } else {
          setFlagNotAvailability(true);
        }
        /*   TotalPagineo = response.data.totalHoteles
  
          const result = Array.from(new Set(response.data.Disponibilidades.map(s => s.hotelOperador)))
            .map(hotelOperador => {
              var OpeAux = response.data.Disponibilidades.filter(s => s.hotelOperador === hotelOperador)[0].Operador
              var codeAux = response.data.Disponibilidades.filter(s => s.hotelOperador === hotelOperador)[0].code
              var TmpHotelsList = (hotelsList.find(v => v.Operador == OpeAux)) ? hotelsList.find(v => v.Operador == OpeAux).Hotels : '';
              if (TmpHotelsList == '') {
                hotelsList.push({ Operador: OpeAux, Hotels: ((hotelsList.length > 0) ? '$' + OpeAux : OpeAux) + '|' + codeAux })
              }
              else {
                hotelsList.find(v => v.Operador == OpeAux).Hotels = TmpHotelsList + ';' + codeAux;
              }
              return {
                codigoHotel: codeAux,
                hotelOperador: hotelOperador,
                itemHotel: response.data.Disponibilidades.filter(s => s.hotelOperador === hotelOperador)
              };
            });
          setTotalPagination(Math.ceil(TotalPagineo / 10))
          var HotelsDetails = []
          if (firstPagination == 1) {
            setdataHotelsDetails(response.data.DetalleHoteles)
            if (response.data.DetalleHoteles.length > 0) {
              setFirstPagination(0);
            }
          }
          if (dataHotelsDetails.length === 0) {
            HotelsDetails = response.data.DetalleHoteles
          } else {
            HotelsDetails = dataHotelsDetails
          }
          GetHotelsDetails(hotelsList.map(a => a.Hotels).toString().replace(',$', '$'), result, HotelsDetails)
          setPrecioDesde(response.data.precioMinimo)
          setPrecioHasta(response.data.precioMaximo) */
        setOpen(false);
      })
      .catch((error) => {
        // setOpen(false);
        // console.log(error);
      });
  };

  const BookingAPI = (bookingP, paxesP) => {
    /* var book = {
      ITEMS: [
        {
          HABITACIONES: [
            {
              PASAJEROS: paxesP,
              ORDEN: 1,
              DESCRIPCION: "Doble Select 2AD",
              CODIGO: "1",
              CODIGOREGIMEN: "TI",
              PRECIO: 10322.94,
            },
          ],
          IDENCABEZADO: bookingP.IDENCABEZADO,
          IDCOMBINADOS: bookingP.IDCOMBINADOS,
          TIPO: "HOTEL",
          DESCRIPCION: bookingP.DESCRIPCION,
          FECHAENTRADA: bookingP.FECHAENTRADA,
          FECHASALIDA: bookingP.FECHASALIDA,
          CODIGO: bookingP.CODIGO,
          PROVEEDOR: bookingP.PROVEEDOR,
          CIUDAD: bookingP.CIUDAD,
          OBSERVACIONES: bookingP.OBSERVACIONES,
        },
      ],
      AGENCIA: [
        {
          NOMBRE: bookingP.NOMBRE,
          NOMBREAGENTE: bookingP.NOMBREAGENTE,
          CORREO: bookingP.CORREO,
        },
      ],
      PASDIRECTO: [
        {
          NOMBRE: bookingP.NOMBRE,
          CELULAR: bookingP.CELULAR,
          TELEFONO: bookingP.TELEFONO,
          CORREO: bookingP.CORREO,
        },
      ],
      ASIGNADOA: "KZ",
      EXPEDIENTEREFERENCIA: "B41254",
    }; */

    const url =
      "https://webtravel2-online.com/APIhoteles/api/Busqueda?session=" +
      searchObject.SearchToken +
      "&DestinationCode=" +
      searchObject.city +
      "&datefrom=" +
      searchObject.from +
      "&dateto=" +
      searchObject.to +
      "&" +
      searchObject.distribution +
      "&agencia=atom";
    axios
      .get(url, {
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        console.log(response);
        setsearchToken(response.data);
        FillPaginationObject(
          {
            cat5: false,
            cat4: false,
            cat3: false,
            cat2: false,
            cat1: false,
          },
          "",
          response.data,
          1,
          [0, 0],
          {
            SA: false,
            AD: false,
            MP: false,
            PC: false,
            TI: false,
          },
          0
        );
      })
      .catch((error) => {
        // setOpen(false);
        setsearchToken("");
        // console.log(error);
      });
  };

  // ---------------------- API(FIN) ---------------------------

  // ---------------------- HANDLE ---------------------------
  /*   const handleClickOpenDialog = () => {
      setOpen(true);
    }; */

    const handleQueryString = () => {
      const search = window.location.search;
      const params = new URLSearchParams(search);
            const foo = params.get('agencia');
          if (foo !== "") {
            setAgenciaWeb(foo);
          }
          switch (AgenciaWeb) {
            case 'Ibero':
              seturlAgencia("https://webtravel2-online.com/serviciosonline2/headeribero.html");   
              break;
            case 'MC':
              seturlAgencia("https://webtravel2-online.com/serviciosonline2/headermc.html");             
              break;
            default:
              seturlAgencia("https://atom.travel/headeratom.html");            
              break; 
          }
    }

    const cambiaUrl = () => {
        if (AgenciaWeb !== "Ibero") {
            seturlAgencia("https://webtravel2-online.com/serviciosonline2/headeribero.html");            
          }
          else {
            seturlAgencia("https://atom.travel/headeratom.html");            
          }
    }

  const handleCloseDialog = () => {
    setOpen(false);
  };

  const handleCloseDialogAvailability = () => {
    setFlagNotAvailability(false);
  };

  const UpdatePaxes = (paxesP) => {
    setPaxes(paxesP);
  };

  const CancelBooking = (flagBooking) => {
    setbookingFlag(flagBooking);
  };

  const FillHotelsFilters = (
    filltersCat,
    hotel,
    token,
    indicePaginacion,
    precioRango,
    fillterReg,
    ClearFiltro,
    destacadosFiltro
  ) => {

    console.log("filltersCat");
    console.log(filltersCat);
    setFlagFilter(false);
    setOpen(true);

    //setFirstPagination(1);

    var pObj = {
      filltersCat: filltersCat,
      hotel: hotel,
      token: token,
      indicePaginacion: 1,
      precioRango: precioRango,
      filltersReg: fillterReg,
    };
    setPaginationObject(pObj);
    setIndexPagination(1);
    FillPaginationObject(
      filltersCat,
      hotel,
      token,
      1,
      precioRango,
      fillterReg,
      destacadosFiltro ? 1 : 0
    );
    if (ClearFiltro) {
      setShowDestacadosAux(true);
    } else {
      setShowDestacados(false);
      setShowDestacadosAux(false);
    }
    //colocado para deshabilitar la secci�n de hoteles destacados
    setShowDestacados(false);
    setShowDestacadosAux(false);
  };

  const ToBookingClick = (
    hotelOperador,
    IDCombinacion,
    Operador,
    IDEncabezado,
    Tipo, 
    token
  ) => {

    console.log("BookingClick")
    console.log(hotelOperador + " " + IDCombinacion + " " + Operador + " " + IDEncabezado + " " + Tipo+ " " + token);
    if (!bookingFlag) {
      if (Tipo === "Destacados") {
        var tmp = dataHotelsDestacados[
          dataHotelsDestacados.findIndex(
            (s) => s.hotelOperador === hotelOperador
          )
        ].itemHotel.filter(
          (s) =>
          s.idCombinacion === IDCombinacion &&
          s.operador === Operador &&
          s.idEncabezado === IDEncabezado&&
          s.token === token
        );
      } else {
        console.log("dataHoltes");
        console.log(dataHotels);
        var tmp = dataHotels[
          dataHotels.findIndex((s) => s.hotelOperador === hotelOperador)
        ].itemHotel.filter(
          (s) =>
            s.idCombinacion === IDCombinacion &&
            s.operador === Operador &&
            s.idEncabezado === IDEncabezado&&
            s.token === token
        );
      }

      /*  var tmp = dataHotels.filter(s => s.hotelOperador === hotelOperador) */
      console.log("tmp")
     console.log(tmp)
     console.log(tmp[0].itemHotel)

      setdataBooking(tmp);
      setbookingFlag(true);
    }
  };

  const BookingClick = (bookingP) => {
    BookingAPI(bookingP, paxes);
  };

  /*   const handleChangeAccordion = (panel) => (event, newExpanded) => {
      setExpanded(newExpanded ? panel : false);
    }; */
  // ---------------------- HANDLE (FIN) ---------------------------

  // ---------------------- FUNCIONES ---------------------------

  const ProcesaHotelsResults = (resultXX, tipoAPI) => {
    var hotelsList = [];
    var TotalPagineo = "";
    TotalPagineo = resultXX.totalServicios;

    const result = Array.from(new Set(resultXX.Disponibilidades.map((s) => s.hotelOperador))).map((hotelOperador) => {
      var OpeAux = resultXX.Disponibilidades.filter((s) => s.hotelOperador === hotelOperador)[0].Operador;
      var codeAux = resultXX.Disponibilidades.filter((s) => s.hotelOperador === hotelOperador)[0].code;
      var TmpHotelsList = hotelsList.find((v) => v.Operador == OpeAux) ? hotelsList.find((v) => v.Operador == OpeAux).Hotels : "";
      if (TmpHotelsList == "") {
        hotelsList.push({
          Operador: OpeAux,
          Hotels: (hotelsList.length > 0 ? "$" + OpeAux : OpeAux) + "|" + codeAux,
        });
      } else {
        hotelsList.find((v) => v.Operador == OpeAux).Hotels = TmpHotelsList + ";" + codeAux;
      }
      return {
        codigoHotel: codeAux,
        hotelOperador: hotelOperador,
        itemHotel: resultXX.Disponibilidades.filter((s) => s.hotelOperador === hotelOperador).sort(function (a, b) {
          if (a.Precio > b.Precio) {
            return 1;
          }
          if (a.Precio < b.Precio) {
            return -1;
          }
          return 0;
        }),
      };
    });
    setTotalPagination(Math.ceil(TotalPagineo / 10));
    var HotelsDetails = [];
    /*     console.log("firstPagination")
        console.log(firstPagination)
        console.log(dataHotelsDetails) */
    if (firstPagination === 1) {
      setdataHotelsDetails(resultXX.DetalleHoteles);
      if (resultXX.DetalleHoteles.length > 0) {
        if (tipoAPI !== "Destacados") {
          setFirstPagination(0);
        }
      }
    }
    if (dataHotelsDetails.length === 0 || (firstPagination === 1) & (tipoAPI !== "Destacados")) {
      HotelsDetails = resultXX.DetalleHoteles;
    } else {
      HotelsDetails = dataHotelsDetails;
    }
    GetHotelsDetails(
      hotelsList
        .map((a) => a.Hotels)
        .toString()
        .replace(",$", "$"),
      result,
      HotelsDetails,
      tipoAPI
    );
    setPrecioDesde(resultXX.precioMinimo);
    setPrecioHasta(resultXX.precioMaximo);
    setIndDestacados(resultXX.indDestacados);
  };

  const ProcesaServiciosResults = (resultXX, tipoAPI) => {
    var hotelsList = [];
    var TotalPagineo = "";
     TotalPagineo = resultXX.totalServicios;


    //LUEGO DE AGREGAR A LA RESPUESTA DE LA DISPO EL CAMPO COMPUESTO DE OPERADOR Y CODIGO CAMBIAR COMO ESTA EL DE HOTELES hotelOperador
    const result = Array.from(new Set(resultXX.Disponibilidades.map((s) => s.codigo))).map((codigo) => {
      //var OpeAux = resultXX.Disponibilidades.filter((s) => s.codigo === codigo)[0].Operador;
      var OpeAux = "GALAXY";
      //var codeAux = resultXX.Disponibilidades.filter((s) => s.hotelOperador === hotelOperador)[0].code;
      var hotelOperador = codigo + "-" + OpeAux;
      var codeAux = codigo;
      var TmpHotelsList = hotelsList.find((v) => v.Operador === OpeAux) ? hotelsList.find((v) => v.Operador === OpeAux).Hotels : "";
      if (TmpHotelsList === "") {
        hotelsList.push({
          Operador: OpeAux,
          Hotels: (hotelsList.length > 0 ? "$" + OpeAux : OpeAux) + "|" + codeAux,
        });
      } else {
        hotelsList.find((v) => v.Operador === OpeAux).Hotels = TmpHotelsList + ";" + codeAux;
      }
      return {
        codigoHotel: codeAux,
        hotelOperador: hotelOperador,
        itemHotel: resultXX.Disponibilidades.filter((s) => s.operador === OpeAux && s.codigo === codeAux).sort(function (a, b) {
          if (a.Precio > b.Precio) {
            return 1;
          }
          if (a.Precio < b.Precio) {
            return -1;
          }
          return 0;
        }),
      };
    });
    setTotalPagination(Math.ceil(TotalPagineo / 10));
    var HotelsDetails = [];
    /*     console.log("firstPagination")
        console.log(firstPagination)
        console.log(dataHotelsDetails) */
/*     if (firstPagination == 1) {
      setdataHotelsDetails(resultXX.DetalleHoteles);
      if (resultXX.DetalleHoteles.length > 0) {
        if (tipoAPI !== "Destacados") {
          setFirstPagination(0);
        }
      }
    }
    if (dataHotelsDetails.length === 0 || (firstPagination == 1) & (tipoAPI !== "Destacados")) {
      HotelsDetails = resultXX.DetalleHoteles;
    } else {
      HotelsDetails = dataHotelsDetails;
    } 
    GetHotelsDetails(hotelsList.map((a) => a.Hotels).toString().replace(",$", "$"),result,HotelsDetails,tipoAPI);
    */
   console.log("RESULT");
   console.log(result);
    setdataHotels(result);
    setOpen(false);
    setPrecioDesde(resultXX.precioMinimo);
    setPrecioHasta(resultXX.precioMaximo);
    //setIndDestacados(resultXX.indDestacados);
  };

  const GetHotelsDetails = (
    listHotels,
    result,
    dataHotelsDetailsX,
    tipoAPI
  ) => {
    var i;

    for (i = 0; i < result.length; i++) {
      let resultTmp = dataHotelsDetailsX.find(
        (v) => v.hotelOperador == result[i].hotelOperador
      );

      if (typeof resultTmp == "undefined") {
      } else {
        var j;
        for (j = 0; j < result[i].itemHotel.length; j++) {
          result[i].itemHotel[j].DescripcionHotel = resultTmp.Descripcion;
          result[i].itemHotel[j].UrlImagen1 = resultTmp.Imagen;
          result[i].itemHotel[j].Direccion = resultTmp.Direccion;
          result[i].itemHotel[j].Latitud = resultTmp.Latitud;
          result[i].itemHotel[j].Longitud = resultTmp.Longitud;
        }
      }
    }

    if (tipoAPI === "Destacados") {
      setdataHotelsDestacados(result);
    } else {
      setdataHotels(result);
      // console.log(result);
    }

    // setdataBooking(result);
    setOpen(false);
  };

  const Search = (SearchO) => {
    if (SearchO == "undefined" || SearchO == "") {
    } else {
      setShowDestacados(false);
      setfirstSearch(true);
      ClearData();
      setsearchObject(SearchO);
    }
  };

  const ClearData = () => {
    setdataHotels([]);
    setdataHotelsDestacados([]);
    setdataBooking([]);
    setdataHotelsDetails([]);
  };

  const FillPaginationObject = (
    filltersCat,
    hotel,
    token,
    indicePaginacion,
    precioRango,
    filltersReg,
    destacadosFiltro
    /*   filltersCat = {
      cat5: false,
      cat4: false,
      cat3: false,
      cat2: false,
      cat1: false,
    },
    hotel = "",
    token = "",
    indicePaginacion = "N",
    precioRango,
    filltersReg = {
      SA: false,
      AD: false,
      MP: false,
      PC: false,
      TI: false, 
    },
    destacadosFiltro */
  ) => {
    var ObjectTmp = paginationObject;
    ObjectTmp.filltersCat = filltersCat;
    ObjectTmp.hotel = hotel;
    ObjectTmp.token = token;
    ObjectTmp.indicePaginacion = indicePaginacion;
    ObjectTmp.precioRango = precioRango;
    ObjectTmp.filltersReg = filltersReg;
    ObjectTmp.destacadosFiltro = destacadosFiltro;
    setPaginationObject(ObjectTmp);
    var pp = new Date();
    SetEpale(pp);
    setFlagFilter(false);
  };

  // ---------------------- FUNCIONES (FIN) ---------------------------

  return (
    <div style={sectionStyleFondo}>
      <a name="one"></a>
      <Container className={classes.container} shadow={true}>
        {AgenciaWeb === "Ibero" ? (
        <Iframe url={urlAgencia}
          width="1240px"
          height="195px"
          id="myId"
          frameBorder="0"
          overflow="hidden"
          // className="myClassname"
          display="initial"
          position="relative" />
        ) : (
          <Iframe url={urlAgencia}
          width="1240px"
          height="281px"
          id="myId"
          frameBorder="0"
          overflow="hidden"
          // className="myClassname"
          display="initial"
          position="relative" />
        )}
        <div className={classes.divFondo}>
          {!bookingFlag ? (
            <div
              style={principalSearch ? sectionStyle : null}
              className={
                principalSearch
                  ? classes.fondoGetCriteria
                  : classes.fondoGetCriteriaPag
              }
            >
              <GetCriteriaHotels
                onClick={Search}
                className={classes.Criterio}
              ></GetCriteriaHotels>
            </div>
          ) : (
            <div></div>
          )}
          {!principalSearch && !bookingFlag ? (
            <Fragment>
              <div className={classes.root}>
                {dataHotels.length === 0 && flagMensajeEspera ? (
                  <Fragment>
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        m={2}
                        p={2}
                        className={classes.buttonSeguimos}
                        variant="outlined"
                      >
                        <Box paddingRight={4}>
                          <CircularProgress style={{ color: "#016AA2 " }} />
                        </Box>
                        <Box>
                          <Typography
                            variant="h5"
                            style={{ fontFamily: "MontserratSemiBold" }}
                          >
                            Seguimos buscando los mejores precios para usted
                          </Typography>
                        </Box>
                        <Box paddingLeft={4}>
                          <CircularProgress style={{ color: "#016AA2 " }} />
                        </Box>
                      </Box>
                    </Grid>
                  </Fragment>
                ) : (
                  <div></div>
                )}
                <Box display="flex" m={1} p={1}>
                  {
                    <Grid container spacing={1}>
                      <Grid item xs={2} className={classes.GridBarra}>
                        <CardFilter
                          onClick={FillHotelsFilters}
                          token={searchToken}
                          dataHotelsDetails={dataHotelsDetails}
                          zoneName={searchObject.zoneName}
                          countryFlag={searchObject.countryFlag}
                          precioDesde={precioDesde}
                          precioHasta={precioHasta}
                          flagFilter={flagFilter}
                          CantDestacados={indDestacados}
                        ></CardFilter>
                      </Grid>
                      <Grid item xs={10}>
                        {ShowDestacados & (indexPagination == 1) ? (
                          <Card
                            style={{
                              backgroundColor: "#FE5215",
                              color: "white",
                              marginBottom: "8px",
                            }}
                          >
                            <CardHeader
                              style={{
                                paddingTop: "0px",
                                paddingBottom: "0px",
                              }}
                              title={
                                <Typography
                                  variant="h6"
                                  style={{
                                    marginTop: "8px",
                                    marginBottom: "8px",
                                    fontFamily: "MontserratSemiBold",
                                  }}
                                >
                                  Hoteles Destacados
                                </Typography>
                              }
                            />

                            <CardContent
                              style={{
                                backgroundColor: "rgb(241 238 238)",
                                /*      borderStyle: "solid",
                                borderColor: "#FE5215",
                                borderWidth: "2px", */
                              }}
                            >
                              <Grid container spacing={1}>
                                <Grid item xs={12}>
                                  {dataHotelsDestacados.map((resultX, i) => (
                                    <HotelCard
                                      onClick={ToBookingClick}
                                      key={i}
                                      hotel={resultX.itemHotel}
                                      zoneName={searchObject.zoneName}
                                      countryFlag={searchObject.countryFlag}
                                      tipo="Destacados"
                                    ></HotelCard>
                                  ))}
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        ) : (
                          /* 

                        <Accordion expanded={expanded === 'panel1'}  style={{ backgroundColor: '#FE5215', color: 'white'}}>
                          <AccordionSummary
                            expandIcon={<ThumbDownIcon style={{color: 'white' }}/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                          >
                            <Typography variant="h5" className={classes.heading} style={{ marginTop: '7px', marginBottom: '7px'}}>Hoteles Destacados</Typography>
                          </AccordionSummary>
                          <AccordionDetails style={{ backgroundColor: '#E0E0E0', borderStyle: 'solid', borderColor: '#FE5215', borderWidth: '3px' }}>
                            <Grid container spacing={1}>
                              <Grid item xs={12} >
                                {dataHotelsDestacados.map((resultX, i) => <HotelCard onClick={ToBookingClick} key={i} hotel={resultX.itemHotel} zoneName={searchObject.zoneName} countryFlag={searchObject.countryFlag} tipo="Destacados"></HotelCard>)}
                              </Grid>
                            </Grid>
                          </AccordionDetails>
                        </Accordion> */
                          <div></div>
                        )}
                        {dataHotels.map((resultX, i) => (
                          <HotelCard
                            onClick={ToBookingClick}
                            key={i}
                            hotel={resultX.itemHotel}
                            zoneName={searchObject.zoneName}
                            countryFlag={searchObject.countryFlag}
                            tipo="Todos"
                            AgenciaWeb={AgenciaWeb}
                          ></HotelCard>
                        ))}
                      </Grid>

                      {dataHotels.length !== 0 ? (
                        <Grid item xs={12}>
                          <div className={classes.Pagination}>
                            <Pagination
                              count={TotalPagination}
                              className={classes.pagination}
                              page={indexPagination}
                              onChange={(event, value) =>
                                setIndexPagination(value)
                              }
                            />
                          </div>
                        </Grid>
                      ) : (
                        <div></div>
                      )}
                    </Grid>
                  }
                </Box>
                {dataHotels.length === 0 && flagMensajeEspera ? (
                  <Fragment>
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        m={2}
                        p={2}
                        className={classes.buttonSeguimos}
                        variant="outlined"
                      >
                        <Box paddingRight={4}>
                          <CircularProgress style={{ color: "#016AA2 " }} />
                        </Box>
                        <Box>
                          <Typography
                            variant="h5"
                            style={{ fontFamily: "MontserratSemiBold" }}
                          >
                            Seguimos buscando los mejores precios para usted
                          </Typography>
                        </Box>
                        <Box paddingLeft={4}>
                          <CircularProgress style={{ color: "#016AA2 " }} />
                        </Box>
                      </Box>
                    </Grid>
                  </Fragment>
                ) : (
                  <div></div>
                )}
              </div>
            </Fragment>
          ) : (
            <div></div>
          )}
          {bookingFlag ? (
            <div className={classes.root}>
              <Box display="flex" m={1} p={1}>
                {
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <HotelBooking
                        onClick={BookingClick}
                        onChange={UpdatePaxes}
                        onCancel={CancelBooking}
                        hotel={dataBooking[0]}
                        fromX={searchObject.from}
                        toX={searchObject.to}
                        distribution={searchObject.distribution}
                        zoneName={searchObject.zoneName}
                        countryFlag={searchObject.countryFlag}
                        AgenciaWeb={AgenciaWeb}
                      ></HotelBooking>
                    </Grid>
                  </Grid>
                }
              </Box>
            </div>
          ) : (
            <div></div>
          )}
        </div>

        {/* MODAL DE LOADING DE HOTELES */}
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          fullScreen={fullScreen}
          open={open}
          onClose={handleCloseDialog}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent>
            <DialogContentText>
              <LoadingHotels
                zoneName={searchObject.zoneName}
                countryFlag={searchObject.countryFlag}
                AgenciaWeb={AgenciaWeb}
              ></LoadingHotels>
            </DialogContentText>
          </DialogContent>
        </Dialog>

        <Dialog
          fullScreen={fullScreen}
          open={flagNotAvailability}
          onClose={handleCloseDialogAvailability}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent>
            <DialogContentText>
              <NotAvailability
                zoneName={searchObject.zoneName}
                countryFlag={searchObject.countryFlag}
                AgenciaWeb={AgenciaWeb}
              ></NotAvailability>
            </DialogContentText>
          </DialogContent>
        </Dialog>
        {/* <img src="/Images/FooterAtom.png" width="1180px"></img> */}
        {AgenciaWeb !== "Ibero" ? (
        <Iframe url="https://atom.travel/footeratom.html"
          width="1240px"
          height="44px"
          id="myId"
          frameBorder="0"
          overflow="hidden"
          // className="myClassname"
          display="initial"
          position="relative" />
        ) :(<div style={{ width: "100% ", height: "20px" }}></div>)}
      </Container>
    </div>
  );
}
